import webNotificationEscl from '../locales/es-CL/webNotification.json';
import webNotificationEsmx from '../locales/es-MX/webNotification.json';
import webNotificationEsco from '../locales/es-CO/webNotification.json';
import webNotificationEnus from '../locales/en-US/webNotification.json';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import showAlert from '../alert/alertHandler';
import showConfirmation from '@waypoint/vue-confirmation';

export default {
  name: 'WebNotification',
  components: {
    Multiselect,
  },
  i18n: {
    messages: {
      'es-CL': {
        webNotification: webNotificationEscl,
      },
      'es-MX': {
        webNotification: webNotificationEsmx,
      },
      'es-CO': {
        webNotification: webNotificationEsco,
      },
      'en-US': {
        webNotification: webNotificationEnus,
      },
    },
  },
  data() {
    return {
      dataAccess: null,
      currentTab: 'gpsNotification',
      activeNotification: false,
      activeSound: false,
      activeWebNotification: false,
      activeSoundWebNotification: false,
      dataNotifications: [],
      dataEmails: null,
      newEmail: null,
      selectedEventNotification: null,
      selectedEvent: null,
      selectedGroupEmails: null,
      searchEmail: null,
      emailsEvents: null,
      isEmailNotificationBusy: false,
      isConfigBussy: false,
      selectedEmailEdit: null,
      newEditEmail: null,
      maxSpeedNotification: null,
      doorOpeningNotification: null,
      exDetentionNotification: null,
      routeDepartureNotification: null,
      panicNotification: null,
      interfNotification: null,
      disconnNotification: null,
      gpsLossNotification: null,
      speedNotification: null,
    };
  },
  async created() {
    await this.prepareData();
  },
  methods: {
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      this.isConfigBussy = true;
      await this.getNotifications();
      this.isConfigBussy = false;
      if (this.dataNotifications) {
        this.displayEmailsForEvent(this.dataNotifications[0]);
      }
    },
    async changeTab(navBar) {
      const ranking = ['gpsNotification', 'webNotification'];
      this.currentTab = navBar;
      const currentTabIndex = ranking.indexOf(this.currentTab);
      this.indexTab = currentTabIndex;
    },
    allActive() {
      if (!this.activeNotification.isActive) {
        this.maxSpeedNotification.isActive = true;
        this.doorOpeningNotification.isActive = true;
        this.exDetentionNotification.isActive = true;
        this.routeDepartureNotification.isActive = true;
        this.panicNotification.isActive = true;
        this.interfNotification.isActive = true;
        this.disconnNotification.isActive = true;
        this.gpsLossNotification.isActive = true;
        this.speedNotification.isActive = true
      } else {
        this.maxSpeedNotification.isActive = false;
        this.doorOpeningNotification.isActive = false;
        this.exDetentionNotification.isActive = false;
        this.routeDepartureNotification.isActive = false;
        this.panicNotification.isActive = false;
        this.interfNotification.isActive = false;
        this.disconnNotification.isActive = false;
        this.gpsLossNotification.isActive = false;
        this.speedNotification.isActive = false;
      }

    },
    checkAllSlide(not) {
      if (!not.isActive) {
        this.activeNotification.isActive = false;
      }
    },
    //trae la informacion de los correos que reciben los eventos
    async getNotifications() {
      const urlNotification = `${this.$store.getters.urlAPI}/notification?notificationType=email_list,web`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let notificacionData = await axios.get(urlNotification, config);

        this.dataNotifications = notificacionData.data.data.types.filter((type) => type.name == 'SECURE_PATH');
        this.dataEmails = notificacionData.data.data.notifications.filter(
          (notification) => notification.notificationTypeName == 'SECURE_PATH',
        );
        let dataWeb = notificacionData.data.data.types.filter((type) => type.name != 'SECURE_PATH');
        let dataWebNotification = notificacionData.data.data.notifications.filter(
          (notification) => notification.notificationTypeName != 'SECURE_PATH',
        );
        dataWeb.forEach((type) => {
          let notification = dataWebNotification.find((notification) => notification.idNotificationType == type.id);
          let enabled = false;
          let haveRecipientes = notification && notification.recipients;
          let idLoggedUser = this.$store.getters.loggedUser.idUser.toString();

          if (type.name == 'GPS_NOTIFICATION' || type.name == 'OPERATION_NOTIFICATION'
            || type.name == 'MAX_SPEED_NOTIFICATION'
            || type.name == 'DOOR_OPENING_NOTIFICATION'
            || type.name == 'EXCESSIVE_DETENTION_NOTIFICATION'
            || type.name == 'ROUTE_DEPARTURE_NOTIFICATION'
            || type.name == 'PANIC_NOTIFICATION'
            || type.name == 'INTERFERENCE_NOTIFICATION'
            || type.name == 'DISCONNECTION_NOTIFICATION'
            || type.name == 'GPS_LOSS_NOTIFICATION'
            || type.name == 'SPEEDING_NOTIFICATION'
          ) {
            enabled = haveRecipientes ? !notification.recipients.includes(idLoggedUser) : true;
          } else {
            enabled = haveRecipientes ? notification.recipients.includes(idLoggedUser) : false;
          }
          let body = {
            isActive: enabled,
            idNotificationType: type.id,
            recipients: haveRecipientes ? notification.recipients : null,
          };
          if (type.name == 'GPS_NOTIFICATION') {
            this.activeNotification = body;
          }
          if (type.name == 'GPS_SOUND') {
            this.activeSound = body;
          }
          if (type.name == 'OPERATION_NOTIFICATION') {
            this.activeWebNotification = body;
          }
          if (type.name == 'OPERATION_SOUND') {
            this.activeSoundWebNotification = body;
          }
          if (type.name == 'MAX_SPEED_NOTIFICATION') {
            this.maxSpeedNotification = body;
          }
          if (type.name == 'DOOR_OPENING_NOTIFICATION') {
            this.doorOpeningNotification = body;
          }
          if (type.name == 'EXCESSIVE_DETENTION_NOTIFICATION') {
            this.exDetentionNotification = body;
          }
          if (type.name == 'ROUTE_DEPARTURE_NOTIFICATION') {
            this.routeDepartureNotification = body;
          }
          if (type.name == 'PANIC_NOTIFICATION') {
            this.panicNotification = body;
          }
          if (type.name == 'INTERFERENCE_NOTIFICATION') {
            this.interfNotification = body;
          }
          if (type.name == 'DISCONNECTION_NOTIFICATION') {
            this.disconnNotification = body;
          }
          if (type.name == 'GPS_LOSS_NOTIFICATION') {
            this.gpsLossNotification = body;
          }
          if (type.name == 'SPEEDING_NOTIFICATION') {
            this.speedNotification = body;
          }
        });
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async postNotifications(body) {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(`${this.$store.getters.urlAPI}/notification`, body, config);
        if (response.data.status) {
          console.log('exito en la creacion');
          return response.data.status;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async patchNotifications(body) {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.patch(
          `${this.$store.getters.urlAPI}/notification/${this.selectedGroupEmails.id}`,
          body,
          config,
        );
        if (response) {
          console.log('exito en la creacion');
          return response.data.status;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async deleteNotifications() {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.delete(
          `${this.$store.getters.urlAPI}/notification/${this.selectedGroupEmails.id}`,
          config,
        );
        if (response) {
          console.log('exito en la eliminacion');
          return response.data.status;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async createEmail() {
      this.isEmailNotificationBusy = true;
      this.isConfigBussy = true;
      let statusCreated = false;
      if (this.newEmail && this.selectedEventNotification) {
        //Verifico si es que hay emails en el evento seleccionado
        if (this.emailsEvents && this.emailsEvents.length > 0) {
          let listEmails = '';
          this.newEmail = this.newEmail.replace(/ /g, '');
          this.newEmail = this.newEmail.replace(/;/g, ',');
          this.emailsEvents.forEach((email) => {
            listEmails = listEmails + email.email + ',';
          });
          listEmails = listEmails + this.newEmail;

          let body = {
            idNotificationType: this.selectedEventNotification.id,
            recipients: listEmails,
            enabled: true,
          };
          statusCreated = await this.patchNotifications(body);
        } else {
          let body = {
            idNotificationType: this.selectedEventNotification.id,
            recipients: this.newEmail,
            idClient: this.$store.getters.clientId,
            enabled: true,
          };
          statusCreated = await this.postNotifications(body);
        }
      }
      if (statusCreated) {
        await this.getNotifications();
        this.refreshEmails(this.selectedEventNotification);
        this.newEmail = null;
      } else {
        showAlert('Error', this.$t('webNotification.modal.errorCreate') + '[' + this.newEmail + ']');
      }
      this.isConfigBussy = false;
      this.isEmailNotificationBusy = false;
    },
    confirmationDelete(email) {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('webNotification.modal.confirmDelete', { email: email }),
        () => {
          this.deleteEmail(email);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    editEmail(email) {
      this.selectedEmailEdit = email;
      this.$bvModal.show('edit-email-modal');
    },
    async saveEdit(id) {
      if (this.newEditEmail) {
        this.isEmailNotificationBusy = true;
        this.isConfigBussy = true;
        let statusCreated = false;
        let listEmails = [];
        this.emailsEvents.forEach((currentEmail) => {
          if (currentEmail.email != this.selectedEmailEdit) {
            listEmails.push(currentEmail.email);
          } else {
            listEmails.push(this.newEditEmail);
          }
        });
        listEmails = listEmails.toString();
        let body = {
          idNotificationType: this.selectedEventNotification.id,
          recipients: listEmails,
          enabled: true,
        };
        statusCreated = await this.patchNotifications(body);

        if (statusCreated) {
          await this.getNotifications();
          this.refreshEmails(this.selectedEventNotification);
        } else {
          showAlert('Error', this.$t('webNotification.modal.errorDelete'));
        }
        this.isEmailNotificationBusy = false;
        this.isConfigBussy = false;
      }
      this.closeModalEdit(id);
      this.newEditEmail = null;
      this.selectedEmailEdit = null;
    },
    async deleteEmail(email) {
      this.isEmailNotificationBusy = true;
      this.isConfigBussy = true;
      let statusCreated = false;
      if (this.emailsEvents.length >= 1) {
        let body = {
          idNotificationType: this.selectedEventNotification.id,
          recipients: email,
          enabled: this.emailsEvents.length > 1 ? true : false,
        };
        statusCreated = await this.patchNotifications(body);
      } 
      if (statusCreated) {
        await this.getNotifications();
        this.refreshEmails(this.selectedEventNotification);
      } else {
        showAlert('Error', this.$t('webNotification.modal.errorDelete'));
      }
      this.isConfigBussy = false;
      this.isEmailNotificationBusy = false;
    },
    /**
     * Metodo que se encarga de refrescar los cambios en los correos
     */
    refreshEmails(event) {
      this.emailsEvents = [];
      //Guardo el grupo que contiene los correos del evento seleccionado
      if (this.dataEmails) {
        this.selectedGroupEmails = this.dataEmails.find((email) => email.idNotificationType == event.id);
        //Guardo en una lista los correos que se tienen del grupo
        if (this.selectedGroupEmails && this.selectedGroupEmails.recipients) {
          let listEmails = this.selectedGroupEmails.recipients.split(',');
          listEmails.forEach((email) => {
            this.emailsEvents.push({
              email: email,
            });
          });
        }
      }
    },
    displayEmailsForEvent(event) {
      this.isEmailNotificationBusy = true;
      this.isConfigBussy = true;
      this.selectedEventNotification = event;
      this.refreshEmails(this.selectedEventNotification);
      this.isConfigBussy = false;
      this.isEmailNotificationBusy = false;
    },
    closeModalEdit(id) {
      this.$bvModal.hide(id);
    },
    async saveConfig() {
      this.isConfigBussy = true;

      let body = [];
      //Transformo el body para añadir o quitar el id de usuario segun corresponda
      this.transformBodyNotification(this.activeNotification);
      this.transformBody(this.activeSound);
      this.transformBodyNotification(this.activeWebNotification);
      this.transformBody(this.activeSoundWebNotification);
      //Guardo el resultado en las variables de entorno para que sean usados por el socket, en el app.js
      this.$store.commit('saveNotificationConfig', this.activeNotification);
      this.$store.commit('saveSoundConfig', this.activeSound);
      this.$store.commit('saveNotificationWebConfig', this.activeWebNotification);
      this.$store.commit('saveSoundConfigWebNotification', this.activeSoundWebNotification);

      body.push(this.activeNotification);
      body.push(this.activeSound);
      body.push(this.activeWebNotification);
      body.push(this.activeSoundWebNotification);

      this.transformBodyNotification(this.maxSpeedNotification);
      this.transformBodyNotification(this.doorOpeningNotification);
      this.transformBodyNotification(this.exDetentionNotification);
      this.transformBodyNotification(this.routeDepartureNotification);
      this.transformBodyNotification(this.panicNotification);
      this.transformBodyNotification(this.interfNotification);
      this.transformBodyNotification(this.disconnNotification);
      this.transformBodyNotification(this.gpsLossNotification);
      this.transformBodyNotification(this.speedNotification);

      this.$store.commit('savemaxSpeedNotification', this.maxSpeedNotification);
      this.$store.commit('savedoorOpeningNotification', this.doorOpeningNotification);
      this.$store.commit('saveexDetentionNotification', this.exDetentionNotification);
      this.$store.commit('saverouteDepartureNotification', this.routeDepartureNotification);
      this.$store.commit('savepanicNotification', this.panicNotification);
      this.$store.commit('saveinterfNotification', this.interfNotification);
      this.$store.commit('savedisconnNotification', this.disconnNotification);
      this.$store.commit('savegpsLossNotification', this.gpsLossNotification);
      this.$store.commit('savespeedNotification', this.speedNotification);

      body.push(this.maxSpeedNotification);
      body.push(this.doorOpeningNotification);
      body.push(this.exDetentionNotification);
      body.push(this.routeDepartureNotification);
      body.push(this.panicNotification);
      body.push(this.interfNotification);
      body.push(this.disconnNotification);
      body.push(this.gpsLossNotification);
      body.push(this.speedNotification);

      console.log(body)

      await this.handleNotification(body);
      await this.getNotifications();
      showAlert(this.$t('common.modals.confirmacionTitulo'), this.$t('webNotification.operationSuccess'));
      this.isConfigBussy = false;
    },
    transformBody(notificationType) {
      let idLoggedUser = this.$store.getters.loggedUser.idUser.toString();
      if (notificationType.isActive) {
        //Si el usuario no esta dentro del listado entonces se añade
        let arrayRecipients = notificationType.recipients;
        if (arrayRecipients) {
          let userIn = arrayRecipients.includes(idLoggedUser);
          if (!userIn) {
            notificationType.recipients = arrayRecipients + ',' + idLoggedUser;
          }
        } else {
          notificationType.recipients = idLoggedUser;
        }
      } else {
        if (notificationType.recipients) {
          let userIn = notificationType.recipients.includes(idLoggedUser);
          if (userIn) {
            //Si esta deshabilitada la opción y el id de usuario existe en los recipientes, entonces se elimina del array
            let array = notificationType.recipients.split(',');
            const indice = array.indexOf(idLoggedUser);
            if (indice !== -1) {
              array.splice(indice, 1);
            }
            const resultado = array.join(',');
            notificationType.recipients = resultado;
          }
        }
      }
      //Este enabled es usado para el back unicamente, lo que define si el toogle se mueve es el isActive
      notificationType.enabled = true;
      return notificationType;
    },
    //En este caso especifico inserta en el listado de recipientes si para que este deshabilitada su funcion
    transformBodyNotification(notificationType) {
      let idLoggedUser = this.$store.getters.loggedUser.idUser.toString();
      if (notificationType.isActive) {
        let userIn = notificationType.recipients ? notificationType.recipients.includes(idLoggedUser) : false;
        if (userIn) {
          //Si esta deshabilitada la opción y el id de usuario existe en los recipientes, entonces se elimina del array
          let array = notificationType.recipients.split(',');
          const indice = array.indexOf(idLoggedUser);
          if (indice !== -1) {
            array.splice(indice, 1);
          }
          const resultado = array.join(',');
          notificationType.recipients = resultado;
        }
      } else {
        //Si el usuario no esta dentro del listado entonces se añade
        let arrayRecipients = notificationType.recipients;
        if (arrayRecipients) {
          let userIn = arrayRecipients.includes(idLoggedUser);
          if (!userIn) {
            notificationType.recipients = arrayRecipients + ',' + idLoggedUser;
          }
        } else {
          notificationType.recipients = idLoggedUser;
        }
      }
      //Este enabled es usado para el back unicamente, lo que define si el toogle se mueve es el isActive
      notificationType.enabled = false;
      return notificationType;
    },
    async handleNotification(body) {
      const urlNotification = `${this.$store.getters.urlAPI}/notification/handlerNotification?notificationType=web`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let notificacionData = await axios.post(urlNotification, body, config);
        return notificacionData.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
  },
  computed: {
    emailsNotification() {
      const common = {
        thClass: 'text-center',
      };
      return [
        {
          key: 'email',
          tdClass: 'text-center',
          label: this.$t('webNotification.modal.emailTable.email'),
          ...common,
        },
        {
          key: 'actions',
          tdClass: 'text-center',
          label: this.$t('webNotification.modal.emailTable.actions'),
          ...common,
        },
      ];
    },
  },
};
